import { useState } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../assets/logo.png";

export default function Login() {
  const navigate = useNavigate();

  const [email, setEmail] =
    useState("");

  const [password, setPassword] =
    useState("");

  const handleLogin = () => {
    if (
      email === "admin@gmail.com" &&
      password === "123456"
    ) {
      localStorage.setItem(
        "token",
        "admin"
      );

      navigate("/create-campaign");
    } else {
      alert("Invalid Credentials");
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center px-4">

      {/* Background Blur */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-0 left-0 w-72 h-72 bg-black/5 rounded-full blur-3xl" />

        <div className="absolute bottom-0 right-0 w-72 h-72 bg-black/5 rounded-full blur-3xl" />
      </div>

      {/* Login Card */}
      <div className="relative bg-white w-full max-w-md rounded-[32px] shadow-xl border border-gray-100 p-8">

        {/* Branding */}
        <div className="flex flex-col items-center mb-8">

          <div className="w-50 h-20 rounded-3xl bg-white shadow-lg border border-gray-100 flex items-center justify-center mb-5 p-3">
  <img
    src={logo}
    alt="Synoweb Logo"
    className="w-full h-full object-contain"
  />
</div>

          <h1 className="text-3xl font-bold text-gray-900 text-center">
            Syno Campaign
          </h1>

          <p className="text-gray-500 mt-2 text-center">
            WhatsApp Campaign Scheduler
          </p>
        </div>

        {/* Form */}
        <div className="space-y-5">

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Email Address
            </label>

            <input
              type="email"
              placeholder="Enter Email"
              value={email}
              onChange={(e) =>
                setEmail(e.target.value)
              }
              className="w-full border border-gray-300 rounded-2xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-black/10"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Password
            </label>

            <input
              type="password"
              placeholder="Enter Password"
              value={password}
              onChange={(e) =>
                setPassword(
                  e.target.value
                )
              }
              className="w-full border border-gray-300 rounded-2xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-black/10"
            />
          </div>

          <button
            onClick={handleLogin}
            className="w-full bg-black hover:bg-gray-900 transition-all text-white py-3 rounded-2xl font-medium shadow-sm"
          >
            Login
          </button>
        </div>

        {/* Footer Branding */}
        <div className="mt-8 pt-6 border-t border-gray-100 text-center">

          <p className="text-xs uppercase tracking-wide text-gray-400 mb-3">
            Powered By
          </p>

          <div className="flex items-center justify-center gap-3">

            <div className="w-10 h-10 rounded-xl bg-black text-white flex items-center justify-center font-bold">
              S
            </div>

            <div className="text-left">
              <p className="font-semibold text-gray-800">
                Synoweb
              </p>

              <p className="text-xs text-gray-500">
                Messaging Solutions
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}